// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sms-test-module__container--hMNPb {
  max-width: 600px;
  padding: 20px 0;
}
.sms-test-module__field--yaRa_ {
  margin-bottom: 20px;
}
.sms-test-module__label--UvKnl {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}
.sms-test-module__select--RRQli {
  width: 100%;
}
.sms-test-module__userInfo--Q29gX {
  margin-bottom: 20px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
}
.sms-test-module__infoLabel--qFPsU {
  font-weight: 500;
  margin-right: 8px;
}
.sms-test-module__infoValue--50xqg {
  color: #1890ff;
  font-family: monospace;
}
.sms-test-module__actions--yEMWY {
  margin-top: 24px;
}
.sms-test-module__warning--g8LDH {
  margin-top: 16px;
  padding: 12px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 4px;
  color: #ad6800;
}
`, "",{"version":3,"sources":["webpack://./components/pages/developer/sms-test/sms-test.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,eAAA;AACF;AAEA;EACE,mBAAA;AAAF;AAGA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAIA;EACE,WAAA;AAFF;AAKA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAHF;AAMA;EACE,gBAAA;EACA,iBAAA;AAJF;AAOA;EACE,cAAA;EACA,sBAAA;AALF;AAQA;EACE,gBAAA;AANF;AASA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAPF","sourcesContent":[".container {\n  max-width: 600px;\n  padding: 20px 0;\n}\n\n.field {\n  margin-bottom: 20px;\n}\n\n.label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.select {\n  width: 100%;\n}\n\n.userInfo {\n  margin-bottom: 20px;\n  padding: 12px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.infoLabel {\n  font-weight: 500;\n  margin-right: 8px;\n}\n\n.infoValue {\n  color: #1890ff;\n  font-family: monospace;\n}\n\n.actions {\n  margin-top: 24px;\n}\n\n.warning {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #fff7e6;\n  border: 1px solid #ffd591;\n  border-radius: 4px;\n  color: #ad6800;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sms-test-module__container--hMNPb`,
	"field": `sms-test-module__field--yaRa_`,
	"label": `sms-test-module__label--UvKnl`,
	"select": `sms-test-module__select--RRQli`,
	"userInfo": `sms-test-module__userInfo--Q29gX`,
	"infoLabel": `sms-test-module__infoLabel--qFPsU`,
	"infoValue": `sms-test-module__infoValue--50xqg`,
	"actions": `sms-test-module__actions--yEMWY`,
	"warning": `sms-test-module__warning--g8LDH`
};
export default ___CSS_LOADER_EXPORT___;
